import {Pipe, PipeTransform} from '@angular/core';
import {DiscountService} from '../services/discount.service';

@Pipe({
    name: 'discountAmount'
})
export class DiscountAmountPipe implements PipeTransform {
    constructor(private discountService: DiscountService) {}

    transform(id: number): any {
        return this.discountService.getDiscountAmountById(id);
    }
}
